// Lib
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { totalVideoViewsConfig } from '@/lib/analytics/kpis/pinterest/totalVideoViews';
import { SIZE_50 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerVideoViewsConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> =
    {
        ...totalVideoViewsConfig,
        size: SIZE_50,
        tooltip: null,
        loader: MediaViewerKpiLoader
    };
